import { axiosInstance } from '../../axios';
import { AdminTool } from './tool.interface';

export function fetchBuiltinTools() {
  return axiosInstance
    .get<AdminTool[]>('/api/admin/tool/builtin')
    .then((response) => response.data);
}

export function fetchMcpTools() {
  return axiosInstance
    .get<AdminTool[]>('/api/admin/tool/mcp')
    .then((response) => response.data);
}

export function setToolApproveRequired(name: string, approveRequired: boolean) {
  return axiosInstance
    .patch<AdminTool>(`/api/admin/tool/${encodeURIComponent(name)}`, {
      approveRequired,
    })
    .then((response) => response.data);
}
